"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecentSelectedProductDataSchema = exports.VISITED_PRODUCTS_PRODUCT_TYPE = void 0;
var zod_1 = require("zod");
exports.VISITED_PRODUCTS_PRODUCT_TYPE = {
    /** 국내숙소 */
    LOCAL_ACCOMMODATION: 'LOCAL_ACCOMMODATION',
    /** 해외숙소 */
    GLOBAL_ACCOMMODATION: 'GLOBAL_ACCOMMODATION',
    /** 국내레저 */
    LOCAL_LEISURE: 'LOCAL_LEISURE',
    /** 국내엔터 */
    LOCAL_ENTERTAINMENT: 'LOCAL_ENTERTAINMENT',
};
exports.RecentSelectedProductDataSchema = zod_1.z.object({
    checkInDate: zod_1.z.string().optional(),
    checkOutDate: zod_1.z.string().optional(),
    productId: zod_1.z.string(),
    productType: zod_1.z.nativeEnum(exports.VISITED_PRODUCTS_PRODUCT_TYPE),
});
